import { useLanguageStore } from '../stores/useLanguageStore';

function getLocale(lang?: string): string {
  const l = lang ?? useLanguageStore.getState().language;
  if (l === 'kn') return 'kn-IN';
  if (l === 'hi') return 'hi-IN';
  return 'en-IN';
}

export function formatDate(isoString: string, lang?: string): string {
  return new Intl.DateTimeFormat(getLocale(lang), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(isoString));
}

export function formatDateTime(isoString: string, lang?: string): string {
  return new Intl.DateTimeFormat(getLocale(lang), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(isoString));
}

export function formatNumber(n: number, lang?: string): string {
  return new Intl.NumberFormat(getLocale(lang)).format(n);
}

/** Format a percentage score to at most 2 decimal places, no trailing zeros. e.g. 62.3333 → "62.33", 70 → "70" */
export function fmtPct(score: number): string {
  return parseFloat(score.toFixed(2)).toString();
}

export function relativeDate(isoString: string): string {
  const diff = Date.now() - new Date(isoString).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}

/**
 * Formats an elapsed duration in milliseconds for display.
 *
 * Absence is handled here rather than at each call site so that "not measured"
 * renders identically everywhere. `null`/`undefined` means the duration was
 * never recorded — an untimed practice session, for example. `<= 0` is treated
 * the same way: it is not a real measurement, and legacy rows written before
 * untimed sessions stored NULL carry a literal 0.
 */
export function formatDuration(ms: number | null | undefined): string {
  if (ms == null || ms <= 0) return '—';
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}
